import React from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Home as HomeIcon,
  NavigateNext as NavigateNextIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { UI, ROUTES } from '../../constants';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    
    const breadcrumbNameMap = {
      [ROUTES.DASHBOARD]: 'Dashboard',
      [ROUTES.AGENTS]: 'Agentes',
      [ROUTES.AGENTS_CREATE]: 'Criar Agente',
      [ROUTES.INTEGRATIONS]: 'Integrações',
      [ROUTES.KNOWLEDGE_BASE]: 'Base de Conhecimento',
      [ROUTES.EXTERNAL_API]: 'API Keys',
      [ROUTES.EXTERNAL_API_CREATE]: 'Criar API Key',
    };

    const breadcrumbs = [
      <Link
        key="home"
        underline="hover"
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          cursor: 'pointer',
          color: 'text.secondary',
          '&:hover': { color: 'primary.main' },
        }}
        onClick={() => navigate(ROUTES.DASHBOARD)}
      >
        <HomeIcon sx={{ mr: 0.5, fontSize: 18 }} />
        Dashboard
      </Link>,
    ];

    let currentPath = '';
    pathnames.forEach((pathname, index) => {
      currentPath += `/${pathname}`;
      const isLast = index === pathnames.length - 1;
      const name = breadcrumbNameMap[currentPath] || pathname;

      if (isLast) {
        breadcrumbs.push(
          <Typography key={currentPath} color="text.primary" sx={{ fontWeight: 500 }}>
            {name}
          </Typography>
        );
      } else {
        breadcrumbs.push(
          <Link
            key={currentPath}
            underline="hover"
            sx={{ 
              cursor: 'pointer',
              color: 'text.secondary',
              '&:hover': { color: 'primary.main' },
            }}
            onClick={() => navigate(currentPath)}
          >
            {name}
          </Link>
        );
      }
    });

    return breadcrumbs;
  };

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      sx={{
        height: UI.HEADER_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      {/* Left side - Breadcrumbs and Title */}
      <Box sx={{ flexGrow: 1 }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ mb: 0.5 }}
        >
          {getBreadcrumbs()}
        </Breadcrumbs>

      </Box>

      {/* Right side - Actions */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title="Notificações">
          <IconButton
            component={motion.div}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            sx={{
              bgcolor: 'action.hover',
              '&:hover': { bgcolor: 'action.selected' },
            }}
          >
            <NotificationsIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Configurações">
          <IconButton
            component={motion.div}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            sx={{
              bgcolor: 'action.hover',
              '&:hover': { bgcolor: 'action.selected' },
            }}
          >
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Header; 